/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Faq_Q2Inputs */

const en_csv_to_json_faq_q2 = /** @type {(inputs: Csv_To_Json_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are quoted fields supported?`)
};

const ko_csv_to_json_faq_q2 = /** @type {(inputs: Csv_To_Json_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`따옴표로 감싼 필드가 지원되나요?`)
};

const ja_csv_to_json_faq_q2 = /** @type {(inputs: Csv_To_Json_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用符で囲まれたフィールドはサポートされていますか？`)
};

/**
* | output |
* | --- |
* | "Are quoted fields supported?" |
*
* @param {Csv_To_Json_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_faq_q2 = /** @type {((inputs?: Csv_To_Json_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_faq_q2(inputs)
	if (locale === "ko") return ko_csv_to_json_faq_q2(inputs)
	return ja_csv_to_json_faq_q2(inputs)
});